import React from 'react'

function Header(){
  return(
    <header className="header-title">
      <h1>MyReads</h1>
    </header>
  )
}

export default Header
